import { combineEpics } from 'redux-observable';
import { PermissionActionTypes, FetchPermissions } from '../actions/PermissionsActions';
import { getFetchPermissionsRequestStatus } from '../selectors/RequestStatusSelector';
import PermissionsAPI from '../api/PermissionsAPI';
import requestEntity from './requestEntity';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchPermissions = requestEntity(new RequestEpicDescriptor({
  apiFunction: PermissionsAPI.getCurrentUserPermissions,
  initiatingActionType: PermissionActionTypes.LOAD_PERMISSIONS,
  requestStatusSelector: getFetchPermissionsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchPermissions
}));
export default combineEpics(fetchPermissions);